import React from 'react';

export default function SrPartnerPageFooter() {
  return (
    <div className="SrPartnerPageFooter">
      <div className="content">
        <span className="title">Powered by</span>
        <div className="logo" />
      </div>
    </div>
  );
}

SrPartnerPageFooter.displayName = 'SrPartnerPageFooter';
